import { t } from "i18next";
import { useEffect, useState } from "react";
import { Button, Form, Tab, Tabs } from "react-bootstrap";
import { KpiSettings, emptyKpiSettings } from "../../../../interfaces/settings";
import { getKpiSettings, updateKpiSettings } from "../../../../services/settings";
import { LoadingSpinner } from "../../../general/loading-spinner";

export function AdminSettings() {
    const [loaded, setLoaded] = useState(false);
    const [kpiSettings, setKpiSettings] = useState<KpiSettings>(emptyKpiSettings);
    const [saving, setSaving] = useState(false);
    const [activeTab, setActiveTab] = useState('kpis');

    useEffect(() => {
        getKpiSettings()
            .then((response: any) => {
                if (response.data.status === '1') {
                    setKpiSettings(response.data.data);
                }
                setLoaded(true);
            })
            .catch((error: any) => {
                console.log(error);
                setLoaded(true);
            });
    }, []);

    const handleSaveKpis = (event: any) => {
        event.preventDefault();
        setSaving(true);

        const body: KpiSettings = {
            perf1: event.target.perf1.value,
            perf2: event.target.perf2.value,
            perf3: event.target.perf3.value,
            perf4: event.target.perf4.value
        };

        updateKpiSettings(body)
            .then((response: any) => {
                if (response.data.status === '1') {
                    setKpiSettings(response.data.data);
                    alert(t('Settings saved successfully'));
                } else {
                    alert(response.data.message || t('Error saving settings'));
                }
                setSaving(false);
            })
            .catch((error: any) => {
                console.log(error);
                alert(t('Error saving settings'));
                setSaving(false);
            });
    };

    if (!loaded) {
        return <LoadingSpinner />;
    }

    return (
        <div className="admin-settings-container">
            <h1>{t('Settings')}</h1>

            <Tabs
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k || 'kpis')}
                className="mb-3"
            >
                <Tab eventKey="kpis" title={t('KPI Labels')}>
                    <div className="settings-section">
                        <h3>{t('KPI Labels Configuration')}</h3>
                        <p className="text-muted">
                            {t('Configure the labels for the 4 performance KPIs used throughout the application')}
                        </p>

                        <Form onSubmit={handleSaveKpis}>
                            <Form.Group className="mb-3" controlId="perf1">
                                <Form.Label>{t('KPI 1 Label')}</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="perf1"
                                    defaultValue={kpiSettings.perf1}
                                    placeholder={t('e.g., Maximum Speed')}
                                    required
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="perf2">
                                <Form.Label>{t('KPI 2 Label')}</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="perf2"
                                    defaultValue={kpiSettings.perf2}
                                    placeholder={t('e.g., Endurance')}
                                    required
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="perf3">
                                <Form.Label>{t('KPI 3 Label')}</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="perf3"
                                    defaultValue={kpiSettings.perf3}
                                    placeholder={t('e.g., Strength')}
                                    required
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="perf4">
                                <Form.Label>{t('KPI 4 Label')}</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="perf4"
                                    defaultValue={kpiSettings.perf4}
                                    placeholder={t('e.g., Agility')}
                                    required
                                />
                            </Form.Group>

                            <div className="actions">
                                <Button type="submit" variant="primary" disabled={saving}>
                                    {saving ? t('Saving...') : t('Save Settings')}
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Tab>

                {/* Aquí se pueden agregar más tabs en el futuro */}
            </Tabs>
        </div>
    );
}
